import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "backupCamera"
const BackupCameraIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M16.242 19.242a.751.751 0 0 1 1.062 1.062 7.5 7.5 0 0 1-8.174 1.625 7.5 7.5 0 0 1-2.434-1.625.751.751 0 0 1 1.062-1.062 6 6 0 0 0 8.484 0" />
          <path d="M14.512 17.234a.75.75 0 1 1 .837 1.244 6 6 0 0 1-6.584.075.75.75 0 0 1 .808-1.263 4.5 4.5 0 0 0 4.939-.056" />
          <path
            fillRule="evenodd"
            d="M14.414 1.5c.688 0 1.29.468 1.456 1.136l.524 2.097 1.19.596a.75.75 0 0 1-.669 1.342l-.415-.208V13.5a2.25 2.25 0 0 1-2.25 2.25H9a2.25 2.25 0 0 1-2.25-2.25V6.463l-.415.208a.75.75 0 0 1-.67-1.342l1.19-.596.525-2.097A1.5 1.5 0 0 1 8.836 1.5zM8.25 13.125H15v-1.5H8.25zm0-6.375H15v-1.5H8.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BackupCameraIcon
